/**
 * Action: Calls backend API to optimize prompt using Gemini.
 * @param {string} prompt
 * @returns {Promise<string>}
 */
export async function enhancePromptWithGemini(prompt) {
  try {
    const res = await fetch('/api/prompt/enhance', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prompt })
    });

    const data = await res.json();
    if (data.success && data.prompt) {
      return data.prompt;
    }
    throw new Error(data.error || 'Failed to enhance prompt');
  } catch {
    // Fallback if backend is not running or offline
    return (
      `Cinematic documentary portrait of avatar: ${prompt}. ` +
      'Photorealistic skin texture, subtle micro-expressions, 35mm master lens, organic shoulder-cam drift'
    );
  }
}
